import { render, staticRenderFns } from "./ScrollingBlockInCardReport.vue?vue&type=template&id=b6bf1ce6&scoped=true&"
import script from "./ScrollingBlockInCardReport.vue?vue&type=script&lang=js&"
export * from "./ScrollingBlockInCardReport.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingBlockInCardReport.vue?vue&type=style&index=0&id=b6bf1ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bf1ce6",
  null
  
)

export default component.exports